// Export utilities for diagram downloads
export const exportToPNG = (diagramCode, diagramType = 'plantuml') => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  
  canvas.width = 800;
  canvas.height = 600;
  
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  
  ctx.strokeStyle = '#cccccc';
  ctx.lineWidth = 2;
  ctx.strokeRect(10, 10, canvas.width - 20, canvas.height - 20);
  
  ctx.fillStyle = '#333333';
  ctx.font = '20px Arial';
  ctx.textAlign = 'center';
  ctx.fillText(`${diagramType.toUpperCase()} Diagram`, canvas.width / 2, 50);
  
  ctx.font = '12px monospace';
  ctx.textAlign = 'left';
  const lines = diagramCode.split('\n').slice(0, 20);
  lines.forEach((line, index) => {
    ctx.fillText(line.substring(0, 80), 30, 100 + (index * 15));
  });
  
  canvas.toBlob((blob) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `diagram-${Date.now()}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }, 'image/png');
};

export const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text).then(() => {
    console.log('Copied to clipboard');
  }).catch(err => {
    console.error('Failed to copy: ', err);
  });
};